import { useState, useEffect } from 'react';

export default countdown;

function countdown(props) {
  const { startFrom, onComplete = Function.prototype, children, paused } = props;
  const [current, setCurrent] = useState(startFrom * 1e3);
  const [previous, setPrevious] = useState(performance.now());
  let interval;

  useEffect(
    () => {
      clearInterval(interval);
      interval = setInterval(() => dec(performance.now()), 400);

      function dec(now) {
        if (!paused) {
          const diff = now - previous;
          const nextCurrent = Math.max(0, current - diff);

          if (nextCurrent > 500) {
            setCurrent(nextCurrent);
          } else {
            onComplete();
            clearInterval(interval);
          }
        }

        setPrevious(now);
      }

      return () => {
        clearInterval(interval);
      };
    },
    [paused]
  );

  return children(current / 1e3);
}
